<template>
    <div class="header" ref='abc' :class="{'index-header':this.$route.path!='/index'}">
        <div class="fff" v-if="this.$route.path==='/index'"></div>
        <img :src="Logo" alt="" class="logo">
        <div class="header-main">
            <div class="header-menus" @mouseleave="menusLeave">
                <div v-for="(item, index) in menus" :key="index" class="header-menu" @mouseenter="menuMouseenter(index)" @mouseleave="menuMouseleave(index)" @click="menuGoto(item.url,item)">
                    <div class="menu-name"  v-if="item.isiconmenu">
                        <p>{{item.mname}}</p>
                        <div class="line" :class="item.active ? 'line-active' : ''"></div>
                    </div>
                    <img v-show="item.children && item.children.length &&item.isiconmenu" :src="Triangle" alt="" class="triangle" :class="item.active ? 'triangle-active' : ''">
                    <div class="child-menus"  v-if="item.children && item.children.length&&item.active " @mouseleave="childMenusLeave">
                        <div class="child-menu" v-for="(childItem, childIndex) in item.children" :key="childIndex" @click.stop="menuGoto(childItem.url,childItem)"  @mouseenter="childMenuMouseenter(childIndex)" @mouseleave="childMenuMouseleave(childIndex)" :class="childItem.active?'child-menu-active':''">
                             <p class="child-menu-name" v-if='childItem.isiconmenu'>{{childItem.mname}}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="others">
            <div class="wechat">
                <svg-icon icon-class="wechat"></svg-icon>
                <div class="qrcode-bg">
                    <img :src="QrCode" alt="">
                </div>
            </div>
            <div class="tel">
                <img :src="Tel" alt="">
                <p>{{telNumber}}</p>
            </div>
        </div>

    </div>
</template>

<script>
import Logo from '@/assets/img/logo.png'
import Triangle from '@/assets/img/triangle.png'
import Tel from '@/assets/img/tel-icon.png'
import QrCode from '@/assets/img/code.png'
import { menulist, baseset } from '@/api/header.js'
export default {
  data () {
    return {
      Logo,
      Triangle,
      Tel,
      QrCode,
      menuDefaultActive: 0,
      menuActive: 0,
      menus: [
        {
          name: '首页',
          goto: '/',
          children: [],
          active: false
        },
        {
          name: '极地探险',
          goto: '',
          children: [
            {
              name: '北极线路',
              goto: '/routerLists',
              active: true
            },
            {
              name: '南极线路',
              goto: '/sRouterLists',
              active: false
            },
            {
              name: '极地探险队',
              goto: '/exploreTeam',
              active: false
            },
            {
              name: '往期回顾',
              goto: '/pastReview',
              active: false
            }
          ],
          active: false
        },
        {
          name: '极地自由行',
          goto: '',
          children: [
            {
              name: '北极船票预定',
              goto: '/arcticShipBooking',
              active: true
            },
            {
              name: '南极船票',
              goto: '/antarcticShipBooking',
              active: false
            },
            {
              name: '自由行攻略',
              goto: '/freeRunning',
              active: false
            }
          ],
          active: false
        },
        {
          name: '主题旅行',
          goto: '/themeLists',
          children: [],
          active: false
        },
        {
          name: '极地俱乐部',
          goto: '',
          children: [],
          active: false
        },
        {
          name: '往期回顾',
          goto: '/pastReview',
          children: [],
          active: false
        }
      ],
      telNumber: '400-100-9884'
    }
  },
  inject: ['reload'],
  created () {
    this.getmenulist()
    this.baseset()
    console.log(this.$route)
  },
  methods: {
    baseset () {
      baseset().then(res => {
        this.telNumber = res.data.data.mobilephone
        this.email = res.data.data.email
        this.QrCode = res.data.data.kfcode
        this.Logo = res.data.data.logo
      })
    },
    getmenulist () {
      menulist({limit: 1000, sort: 'orderNo', order: 'asc'}).then(res => {
        console.log(res)
        let items = this.toTree(res.data.data.items)
        for (let i = 0; i < items.length; i++) {
          if (!items[i].children) {
            items[i].children = []
          }
        }
        this.menus = items
        this.$store.state.menuid = this.menus[0].id
        console.log(this.menus)
      })
    },
    toTree (data) {
      // 删除 所有 children,以防止多次调用
      data.forEach(function (item) {
        delete item.children
      })

      // 将数据存储为 以 id 为 KEY 的 map 索引数据列
      var map = {}
      data.forEach(function (item) {
        item.active = false
        map[item.id] = item
      })
      //        console.log(map);
      var val = []
      data.forEach(function (item) {
        // 以当前遍历项，的pid,去map对象中找到索引的id
        var parent = map[item.parentid]
        // 好绕啊，如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
        if (parent) {
          (parent.children || (parent.children = [])).push(item)
        } else {
          // 如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
          val.push(item)
        }
      })
      return val
    },
    menusLeave () {
      this.menus[this.menuDefaultActive].active = false
    },
    resetMenuHover () {
      let menus = this.menus

      menus.forEach(item => {
        item.active = false
      })
    },
    menuMouseenter (index) {
      this.resetMenuHover()
      this.menuActive = index
      this.menus[index].active = true
    },
    menuMouseleave (index) {
      this.resetMenuHover()
      this.menuActive = this.menuDefaultActive
      this.menus[index].active = false
    },
    childMenusLeave () {
      this.menus[this.menuActive].children[0].active = true
    },
    childMenuMouseleave (index) {
      this.menus[this.menuActive].children[index].active = false
    },
    childMenuMouseenter (index) {
      this.menus[this.menuActive].children[index].active = true
    },
    menuGoto (goto, item) {
      this.$store.state.menuid = item.id
      this.$store.state.menuname = item
      // const path = this.$route.path
      // if (item.children) {
      //   return
      // }
      // if (this.$route.path === goto || !goto) {
      //   return
      // }
      this.reload()
      this.$router.push({path: goto, query: {id: item.id, img: item.topimg, name: item.mname}})
    }
  }
}
</script>

<style lang="scss" scoped>
.index-header{
  background:rgba(0,0,0,0.5);
}
.header {
    height: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    .fff{
      width:100%;
      height:150px;
      position: absolute;
      top:0;
      left:0;
      opacity: 0.5;
      background:url('../assets/opacity-png.png') repeat-x;
      // background: linear-gradient(#000, rgba(255,255,255,0.1));
      // box-shadow: 0px 0px 10px rgba(255,255,255,0.1);
    }

    &:hover {
        // background: rgba(0, 0, 0, 0.5);
        // transition: all 0.3s;
    }
    .logo {
        width: 160px;
        margin-left: 31px;
    }
    .header-main {
        flex:1;
        .header-menus {
            width: 100%;
            height: 75px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            position: relative;
        }
        .menu-name {
            font-size: 14px;
            color: #fff;
            font-weight: bold;
            line-height: 25px;
        }
        .line {
            width: 0;
            border-bottom: 2px solid transparent;
            margin: 0 auto;
            transition: width 0.3s ease-in-out;
        }
        .line-active {
            width: 50%;
            border-bottom: 2px solid #fff;
            transition: width 0.3s ease-in-out;
        }
        .header-menu {
            height: 75px;
            display: flex;
            justify-content: center;
            align-items: center;
            // padding: 0 16px;
            margin-right:42px;
            cursor: pointer;
            position: relative;
        }
        .triangle {
            width: 7px;
            height: 4px;
            margin-left: 5px;
            transform: rotate(180deg);
            transition: transform 0.3s;
        }
        .triangle-active {
            transform: rotate(0deg);
            transition: transform 0.3s;
        }
        .child-menu-name {
            min-width: 85px;
            width: auto;
            display:inline-block;
            white-space:nowrap;
            text-align: center;
            // padding: 18px 25px;
            padding: 20px 0;
            font-size: 14px;
            color: #fff;
            border-bottom: 1px solid #525e69;
            font-weight: bold;
        }
        .child-menus {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            position: absolute;
            top: 75px;
            z-index: 1000;
            background: rgba($color: #000000, $alpha: 0.5);
            overflow: hidden;
            :last-child .child-menu-name{
                border-bottom: 0;
            }
        }
        .child-menu {
            width: 150px;
            display: flex;
            justify-content: center;
        }
        .child-menu-active {
            background: #047fc8;
        }
        .child-menu-active .child-menu-name {
            border-bottom: 1px solid transparent;
        }
    }
    .others {
        margin-left:58px;
        height: 75px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 30px;
        position: relative;
        .wechat {
            height: 75px;
            // width: 60px;
            margin-right:16px;
            display: flex;
            justify-content: center;
            align-items: center;
            // margin-left: 35px;
            cursor: pointer;
            position: relative;
            svg {
              font-size: 20px;
            }
            &:hover .qrcode-bg {
                width: 168px;
                height: 180px;
                position: absolute;
                top: 50px;
                left: -115px;
                z-index: 1000;
                background: url("../assets/img/qrcode-bg.png");
                img {
                    width: 152px;
                    height: 152px;
                    margin: 20px 0 0 10px;
                }
            }
        }
        .qrcode-bg {
            width: 0;
            height: 0;
            overflow: hidden;
        }
        .tel {
            display: flex;
            align-items: center;
            margin-right:20px;
            img {
                width: 20px;
                height: 16px;
                margin-top: -2px;
            }
            p {
                margin-left: 16px;
                font-weight: bolder;
                color: #fff;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue